<template>
    <el-container style="min-height: 100vh;">
      <el-header style=" color: black; display: flex; align-items: center; justify-content: space-between; padding: 20px 20px; height: 63px;">
        <a href="/" style="display: flex; align-items: center; color: inherit; text-decoration: none;z-index: 1">
          <img src="../assets/gsyj-logo.png" alt="Logo" style="height: 40px;" />
        </a>
        <el-menu :default-active="$route.name" mode="horizontal" class="custom-menu" style="flex: 7; justify-content: flex-end;">
          <el-menu-item index="home"><router-link to="/" style="text-decoration: none; color: inherit;">首页</router-link></el-menu-item>
          <el-sub-menu index="achievements">
            <template #title>服务</template>
            <el-menu-item index="achievements-gitee">
              <router-link to="/project-list.html" style="text-decoration: none; color: inherit;">
                <span>好工长</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="achievements-github">
              <router-link to="/about.html" style="text-decoration: none; color: inherit;">
                <span>设计师</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="achievements-nuget">
              <router-link to="/building.html" style="text-decoration: none; color: inherit;">
                <span>建材选购</span>
              </router-link>
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item index="committee"><router-link to="/committee-list.html" style="text-decoration: none; color: inherit;">用户端</router-link></el-menu-item>
          <el-menu-item index="members"><router-link to="/member-list.html" style="text-decoration: none; color: inherit;">商家入驻</router-link></el-menu-item>
          <el-menu-item index="hezuopinpai"><router-link to="/hezuopinpai.html" style="text-decoration: none; color: inherit;">合作品牌</router-link></el-menu-item>
        </el-menu>
      </el-header>

      <el-main style="">
        <router-view></router-view>
      </el-main>

      <el-footer style="text-align: center; line-height: 60px; height: 60px;">
      </el-footer>
    </el-container>

  </template>

  <script>
  export default {
    name: 'BaseLayout'
  };
  </script>

  <style>
  .custom-menu {
    background-color: transparent !important;
    border-bottom: none !important;
  }

  .el-header > .el-menu.custom-menu {
    border-bottom: none !important;
  }
  </style>